<script setup lang="ts">
  import { BOX_CARD } from '@/cypaths/cyComponents';
  import type { BoxCardProps } from '@/components/common/BoxCard/boxCard';
  import { computed } from 'vue';

  const slots = defineSlots<{
    default: void;
    header?: void;
    footer?: void;
    help?: void;
  }>();

  defineOptions({
    name: 'BoxCard',
  });

  const {
    title = '',
    padded = false,
    gapped = true,
  } = defineProps<BoxCardProps>();

  const headerClass = computed<string>(() => {
    if (slots.help) {
      return '[grid-template-areas:"title_helpButton"_"help_help"] grid-cols-[1fr_min-content]';
    }
    return '[grid-template-areas:"title"] grid-cols-1';
  });
</script>

<template>
  <div
    :data-cy="BOX_CARD"
    data-testid="box-card"
    class="box-card flex flex-col bg-white md:rounded"
    :class="[{
      'px-5 py-8 md:p-8': padded,
      'gap-6': gapped
    }, classes?.wrapper]"
  >
    <template v-if="!$slots.help">
      <slot name="header">
        <h2
          v-if="title"
          v-bind="classes?.header ? { class: classes.header } : undefined"
        >
          {{ title }}
        </h2>
      </slot>
    </template>
    <div
      v-else-if="$slots.header || title"
      style="--min-gap-pct: calc(var(--spacing-6) / var(--breakpoint-md) * 100%)"
      class="grid items-start gap-x-[min(var(--min-gap-pct),var(--spacing-6))]"
      :class="[headerClass, classes?.header]"
    >
      <slot name="header">
        <h2
          v-if="title"
          class="[grid-area:title]"
        >
          {{ title }}
        </h2>
      </slot>
      <slot name="help" />
    </div>
    <slot />
    <slot name="footer" />
  </div>
</template>
